import { useForm, formRootRule, isNotEmpty } from '@mantine/form';

import { useShowResponseStatus } from '@/shared';
import { useCreatePaymentMethodCredentialsMutation } from '../store/payment-methods-api';
import { useGetShops } from '@/modules/shops';

import type { TPaymentMethodCreateCredentialsParams, TPaymentMethod } from '../store/types';

type FormData = TPaymentMethodCreateCredentialsParams;

type Params = {
  paymentMethod: TPaymentMethod;
  onClose: () => void;
};

export const useCreateMethodCredentials = ({ paymentMethod, onClose }: Params) => {
  const [createMethodCredential, {
    isLoading: isCreateLoading,
    isSuccess,
    isError,
  }] = useCreatePaymentMethodCredentialsMutation();

  const {
    data: shops,
    isLoading: isShopsLoading,
  } = useGetShops('regular');

  const isLoading = isCreateLoading || isShopsLoading;

  const initialValues: FormData = {
    methodId: paymentMethod.id,
    fields: [
      {
        name: '',
        value: '',
      },
    ],
    validFor: paymentMethod.data?.step1.options.map((option) => option.name) ?? [],
  };

  const form = useForm<FormData>({
    mode: 'uncontrolled',
    initialValues,
    validate: {
      fields: {
        [formRootRule]: isNotEmpty('Добавьте хотябы один реквизит'),
        name: isNotEmpty('Введите заголовок реквизита'),
        value: isNotEmpty('Введите значение реквизита')
      },
      validFor: isNotEmpty('Выберите способы оплаты'),
    },
  });

  useShowResponseStatus({
    isSuccess,
    successMessage: 'Реквизит в платёжный метод успешно добавлен',
    isError,
    errorMassage: 'При добавлении реквизита произошла ошибка',
  });

  const handleSubmit = async (values: TPaymentMethodCreateCredentialsParams) => {
    const result = await createMethodCredential(values);

    if ('error' in result) {
      return;
    }

    onClose();
  };

  return {
    form,
    shops,
    isLoading,
    handleSubmit,
    // createMethodCredential,
  };
};
